"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllCheckboxes = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * Returns an object with the checkbox status of all purposes.
 */
function getAllCheckboxes() {
    return (0, get_zaraz_1.getZaraz)().consent.getAllCheckboxes();
}
exports.getAllCheckboxes = getAllCheckboxes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWFsbC1jaGVja2JveGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnNlbnQvZ2V0LWFsbC1jaGVja2JveGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG9EQUFnRDtBQUVoRDs7R0FFRztBQUNILFNBQWdCLGdCQUFnQjtJQUM5QixPQUFPLElBQUEsb0JBQVEsR0FBRSxDQUFDLE9BQU8sQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDO0FBQy9DLENBQUM7QUFGRCw0Q0FFQyJ9